export default __webpack_public_path__ + "static/media/antp_ingvehicular_RicardoCortazar_Movil.1cf9457d.jpg";